
const orders_transformer = async function(response) {
  return JSON.parse(response?.data?.message ?? "[]")
}

export default orders_transformer
